export default __webpack_public_path__ + "static/profile_picture-b2748398ba8355d2b2f98480650bc4c2.jpg";